module.exports = __webpack_public_path__ + "img/i-2.d5e8aa8e.jpg";